import { DocumentsClient } from '@src/documents/services/DocumentsClient';
import type { Document } from '@src/orders/domain/PermitApplication';
import { useMutation } from '@tanstack/react-query';

export const useUploadStatePermit = ({
  permitApplicationId,
  orderId,
  onSuccess,
  onError,
}: {
  permitApplicationId: string;
  orderId: string;
  onSuccess: (newDocument: Document) => void;
  onError: (error: Error) => void;
}) => {
  const { mutate, isPending } = useMutation({
    mutationFn: (file: File) =>
      DocumentsClient.uploadStatePermit({ file, permitApplicationId, orderId }),
    onSuccess: (newDocument: Document) => onSuccess(newDocument),
    onError,
  });

  return {
    uploadStatePermit: mutate,
    isPending,
  };
};
